import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { ReportActions, ReportDescription, ReportSection } from '../AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../AdminSUView/Tournaments/Tournaments.css';
import { uploadReport } from 'Src/helpers/service/admin/report';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING as TYPES } from 'Src/consts/report';
import { TournamentSchoolStartListReportForm } from '../AdminView/Tournaments/Reports/TournamentSchoolStartListReportForm/TournamentSchoolStartListReportForm';
import { TournamentSchoolPlayersReportForm } from '../AdminView/Tournaments/Reports/TournamentSchoolPlayersReportForm/TournamentSchoolPlayersReportForm';
import { HighLevelTournamentAreaStartListReportForm } from '../AdminSUView/HighLevelTournaments/Reports/HighLevelTournamentAreaStartListReportForm/HighLevelTournamentAreaStartListReportForm';
import { HighLevelTournamentSchoolAdminsAreaSideReportForm } from '../AdminSUView/HighLevelTournaments/Reports/HighLevelTournamentSchoolAdminsAreaSideReportForm/HighLevelTournamentSchoolAdminsAreaSideReportForm';
import { TournamentResultsIndividualParticipantSideReportForm } from '../AdminSUView/HighLevelTournaments/Reports/TournamentResultsIndividualParticipantSideReportForm/TournamentResultsIndividualParticipantSideReportForm';
import { isIndividualTournament } from 'Src/helpers/tournament/tournament';
import { errorMessage } from 'Src/helpers/service/adminSU/highLevelTournament';

export function ParticipantReports({ user, tournament, union, onClose }: any) {
  const [report, setReport] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');
  const submit = async (data: any, type: string) => {
    if (busy) return;
    let params: any = { tournamentId: tournament.id };
    if (union)
      params =
        type === TYPES.TOURNAMENT_RESULTS_INDIVIDUAL_PARTICIPANT_SIDE
          ? {
              ...params,
              participantSchoolId: user.activeSchoolId,
              showBlank: data.isShowBlank,
              printFullNames: data.isPrintFullNames
            }
          : {
              ...params,
              unionId: user.activeSchoolId,
              showBlank: data.isShowBlank,
              highlightNoAge: data.isHighlightNoAge,
              showAllAdmins: data.isShowAllAdmins
            };
    else
      params = {
        ...params,
        schoolId: user.activeSchoolId,
        showBlank: data.isShowBlank,
        highlightNoAge: data.isHighlightNoAge,
        printFullNames: data.isPrintFullNames,
        printFormName: data.isPrintFormName,
        printYearGroup: data.isPrintYearGroup,
        printGender: data.isPrintGender,
        printDOB: data.isPrintDOB
      };
    setBusy(true);
    setError('');
    try {
      const result = await uploadReport(user, type, { reportParamsCSV: params });
      if (!result?.reportId) throw new Error('The report could not be generated.');
      window.open(
        `${window.apiBase}/public/report/${result.reportId}/reportType/${result.reportType}`,
        '_blank',
        'noopener'
      );
      onClose();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  const back = () => {if (!busy) {setReport(''); setError('');}};
  const formProps = { onCloseClick: back, onSubmit: submit };
  const reports = [
    ...(!union || isIndividualTournament(tournament) ? [{key: 'start', name: 'Start list', description: 'Students and their event allocations.', format: 'Excel'}] : []),
    ...(!union ? [{key: 'players', name: 'Tournament players', description: 'Students entered by your school.', format: 'Excel'}] : []),
    ...(union && isIndividualTournament(tournament) ? [{key: 'results', name: 'Tournament results', description: 'Results for your participating team.', format: 'Excel'}] : []),
    ...(union ? [
      {key: 'schools', name: 'School contact details', description: 'Contacts for the schools represented in your team.', format: 'Excel'},
      {key: 'availability', name: 'Availability report', description: 'Students, school responses, events, selection sources and last editor.', format: 'Excel'}
    ] : [])
  ];
  const activeReport = reports.find(item => item.key === report);
  const reportIcon = <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" /></svg>;
  return (
    <>
    <SimpleModal
      customClass="eEventPrintModal unionTournamentReportsModal"
      isOpen={!report}
      title="Printed forms & reports"
      onCloseClick={onClose}
      showFooter={false}
      isBodyBold={false}
    >
      <div className="eEventPrintModal__intro">Choose a report. You can configure its contents on the next step.</div>
      <section className="eEventPrintModal__group">
        <h3 className="eEventPrintModal__groupTitle">{tournament.name}</h3>
        <div className="eEventPrintModal__list">{reports.map(item => <button type="button" className="eEventPrintModal__item" key={item.key} aria-label={item.name}
          onClick={() => {setReport(item.key); setError('');}}>
          <span className="eEventPrintModal__itemIcon" aria-hidden="true">{reportIcon}</span>
          <span className="eEventPrintModal__itemCopy"><span className="eEventPrintModal__itemHeading"><span>{item.name}</span><span className="eEventPrintModal__format">{item.format}</span></span>
            <span className="eEventPrintModal__itemDescription">{item.description}</span></span>
          <span className="eEventPrintModal__arrow" aria-hidden="true">›</span>
        </button>)}</div>
      </section>
    </SimpleModal>
    <SimpleModal
      customClass="unionTournamentReportParametersModal"
      isOpen={Boolean(report)}
      title={<div className="unionTournamentReportTitle"><span className="unionTournamentReportTitle__icon" aria-hidden="true">{reportIcon}</span>
        <span><strong>{activeReport?.name}</strong><small>Tournament report · {activeReport?.format}</small></span></div>}
      onCloseClick={back}
      bodyClassName="unionTournamentReportParametersModal__body"
      showFooter={false}
      isBodyBold={false}
      dialogStyle={{ maxWidth: 480 }}
    >
        {report === 'start' ? (
          union ? (
            <HighLevelTournamentAreaStartListReportForm {...formProps} />
          ) : (
            <TournamentSchoolStartListReportForm {...formProps} tournament={tournament} />
          )
        ) : report === 'players' ? (
          <TournamentSchoolPlayersReportForm {...formProps} tournament={tournament} />
        ) : report === 'results' ? (
          <TournamentResultsIndividualParticipantSideReportForm {...formProps} />
        ) : report === 'schools' ? (
          <HighLevelTournamentSchoolAdminsAreaSideReportForm {...formProps} />
        ) : report === 'availability' ? <form className="eReportForm unionTournamentReportForm" onSubmit={event => {event.preventDefault(); submit({}, TYPES.HIGH_LEVEL_TOURNAMENT_AVAILABILITY);}}>
          <div className="eReportForm__content"><ReportDescription>Download school availability for all students in your tournament squad.</ReportDescription>
            <ReportSection number={1} title="Report content" hint="Includes every page of your squad, regardless of filters in the student list.">
              <p>Student, date of birth and school, availability status, request and deadline, event allocations, selection sources and the last editor.</p>
              <p><strong>Format:</strong> Excel workbook (.xlsx) · Students and school summary</p>
            </ReportSection></div>
          <ReportActions onCancel={back} disabled={busy} submitLabel="Generate report" />
        </form> : null}
        {busy && <div className="unionTournamentReportLoading" role="status" aria-live="polite"><span className="unionTournamentReportLoading__spinner" aria-hidden="true" /><strong>Generating report</strong><small>This may take a moment.</small></div>}
        {error && <div className="unionTournamentReportStatus is-error" role="alert">{error}</div>}
    </SimpleModal>
    </>
  );
}
